import { render, staticRenderFns } from "./Visualizar-Faturas.vue?vue&type=template&id=79e4a482&scoped=true&"
import script from "./Visualizar-Faturas.vue?vue&type=script&lang=js&"
export * from "./Visualizar-Faturas.vue?vue&type=script&lang=js&"
import style0 from "./Visualizar-Faturas.vue?vue&type=style&index=0&id=79e4a482&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e4a482",
  null
  
)

export default component.exports